export default {
  state: {
    userInfo: {
      email: "",
      password: "",
    },
  },
};
